var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-bootstrap-typeahead',{attrs:{"data":_vm.stores,"serializer":s => s.company_name + ' - ' + s.name,"placeholder":"Find a store..."},on:{"hit":function($event){_vm.selectedStore = $event}},model:{value:(_vm.storeSearch),callback:function ($$v) {_vm.storeSearch=$$v},expression:"storeSearch"}})
}
var staticRenderFns = []

export { render, staticRenderFns }